import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalTidakAdaDokter extends React.Component {
    render() {
        const { showModalNoDokter, cancelHandler, DeleteHandler2, Model, List, janjiHandler, janjiHandler2, editHandler, saveHandler, Model2, office_id, idOffice } = this.props

        return (
            <div>
                
                <Modal show={showModalNoDokter} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>CEK KETERSEDIAAN JADWAL</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Mohon maaf, Tidak ada jadwal dokter yang bersangkutan pada tanggal tersebut <br /> <br />
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Batal</button>
                        <button class="btn btn-danger" onClick={()=>{janjiHandler2(idOffice)}}>Pilih Tanggal Lain </button>
                        {/* <Modal onHide={showModalNoDokter} ></Modal> */}
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}